export default "__VITE_ASSET__fdd764ab__"